<template>
    <base-section header="Svatební menu">
        <div class="item">
            <div class="key">Přípitek</div>
            <div class="value">Bohemia Sekt Ryzlink rýnský suchý</div>
        </div>
        <div class="item">
            <div class="key">Předkrm</div>
            <div class="value">Salát z rukoly s kozím sýrem pečeným ve slanině Pancetta Tessa Affumicata s krémovým balsamicem a bylinkovými tousty</div>
<!--            <div class="transcript">(Sýr ve slanině na rukole)</div>-->
        </div>
        <div class="item">
            <div class="key">Polévka</div>
            <div class="value">Hovězí consomé se zeleninovým julienne</div>
<!--            <div class="transcript">(Hovězí vývar se zeleninou)</div>-->
        </div>
        <div class="item">
            <div class="key">Hlavní chod</div>
            <div class="value">Francouzská kachní prsa s omáčkou z Armagnacu a červeného pepře, bramborový
                koláček, gratinovaná zelenina s tymiánem a čedarem</div>
<!--            <div class="transcript">(Kachní prsa se zapečenými brambory a teplou zeleninou)</div>-->
        </div>

        <hr class="my-4"/>
        <div class="text-xs-center">Po celý den nápoje na baru: točená Plzeň, točený Kozel, točený Birell pomelo & grep, víno, káva, nealko</div>

    </base-section>
</template>
<script>
    import BaseSection from "@/components/BaseSection"

    export default {
        name: 'section-wedding-menu',
        components: {BaseSection}
    }
</script>

<style scoped lang="stylus">
    .item {
        text-align: center;
        .key {
            font-size: 1.25rem
            line-height: 1.25rem
            margin-top 1rem;

        }
        .transcript {
          font-size: 0.9rem
         }
    }
    hr {
        display: block;
        height: 1px;
        border: 0;
        border-top: 1px solid var(--v-primary-base);
        margin: 1rem 0.5rem;
        padding: 0;
    }
</style>